import { styled, TextField } from '@mui/material'

export const FilterContainer = styled('div')({
  padding: '1rem 1rem 0',
  '& >div': {
    display: 'flex',
    '&:last-of-type': {
      minHeight: 21,
      marginBottom: 4,
    },
  },
})

export const SortByContainer = styled('div')({
  alignItems: 'center',
  height: 28,
  marginTop: 8,
  '& p:nth-of-type(2,3)': {
    cursor: 'pointer',
  },
})

export const ZipcodeInput = styled(TextField)(({ theme }) => ({
  marginRight: 10,
  '& .MuiInputBase-root.MuiOutlinedInput-root:hover fieldset': {
    border: `2px solid ${theme.palette.primary.main}`,
  },
  '& fieldset': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  '& input': {
    border: 'none',
  },
}))
